import { render, staticRenderFns } from "./KrafAnalytics.vue?vue&type=template&id=09f6b566"
import script from "./KrafAnalytics.vue?vue&type=script&lang=js"
export * from "./KrafAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports